// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isGetCustomObjectsCustomObjectTypeAttributesResult = objectOf({
  items: arrayOf(
    objectOf({
      id: number,
      display_name: string,
      json_type: string,
    })
  ),
});
